export enum AlertReferenceTypeEnum {
  Case = "Case",
  Youth = "Youth",
  SnapInSchoolsCycle = "SnapInSchoolsCycle",
}
